import React from 'react';
import { useSelector } from 'react-redux';
import LedgerList from './LedgerDetails';

const Ledger = () => {
    const { showAccountingMenu } = useSelector((state) => state.accountingReducer);

    return (
        <div className={` ${showAccountingMenu ? 'col-10' : 'col-12'}`}>
            <LedgerList />
        </div>
    );
}

export default Ledger;